import {
  ApiBlueprint,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/frontend-plugin-api';
import { keyVaultApiRef } from '../api/KeyVaultApi';
import { KeyVaultClient } from '../api/KeyVaultClient';

// Registers KeyVaultClient as the implementation of keyVaultApiRef. Uses
// DiscoveryApi to resolve `/api/key-vault` and FetchApi so Backstage's
// user-token interception applies automatically.
export const keyVaultApiExtension = ApiBlueprint.make({
  name: 'key-vault-api',
  params: defineParams =>
    defineParams({
      api: keyVaultApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new KeyVaultClient(discoveryApi, fetchApi),
    }),
});
